// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"38a543d7","239":"488c1303","453":"6e5a8dbf","732":"87b2b0fb"}[chunkId] + ".chunk.js";
};